import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { FaHome, FaEnvelope, FaFileAlt, FaUser, FaSignOutAlt, FaClipboardList, FaChartBar } from 'react-icons/fa';
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <h1>📧 ISP Policy Monitor</h1>
      </div>

      <div className="navbar-menu">
        <button onClick={() => navigate('/')} className="nav-item">
          <FaHome /> Home
        </button>
        <button onClick={() => navigate('/updates')} className="nav-item">
          <FaEnvelope /> Updates
        </button>
        <button onClick={() => navigate('/digest')} className="nav-item">
          <FaFileAlt /> Digest
        </button>
        <button onClick={() => navigate('/compliance')} className="nav-item">
          <FaClipboardList /> Compliance
        </button>
        <button onClick={() => navigate('/analytics')} className="nav-item">
          <FaChartBar /> Analytics
        </button>
        <button onClick={() => navigate('/profile')} className="nav-item">
          <FaUser /> Settings
        </button>
      </div>

      <button onClick={handleLogout} className="logout-btn">
        <FaSignOutAlt /> Logout
      </button>
    </nav>
  );
}

export default Navbar;
